import Container from "@material-ui/core/Container";
import React, { Component } from 'react';
import MyButton from "../Buttons/MyButton";
import Grid from '@material-ui/core/Grid';
import ConfirmTool from "./ConfirmTool";
import TextTerms from "./TextTerms";
import "./ConfirmTool.css";
import { withRouter } from "react-router-dom";
import { Checkbox } from '@material-ui/core';


  class Confirm extends Component {
    constructor(props) {
      super(props);
      this.state = { value: true ,isLoading: true, allData: {}};
  }

  changeEnable = () => {
    let possible = this.state.value ? false : true
    this.setState({value: possible})
  };

  handleClick = () => {
    this.props.history.push('/');
  }

    render() {
      return (
         <Container component="main" maxWidth="xs">
          <ConfirmTool textPage="תנאי שימוש"/>
          <TextTerms/>
            <p>
            <Grid container direction={'row'}>
            <p><Checkbox
              name="confirm_terms"
              defaultChecked={false}
              value="secondary"
              color="primary"
              onClick={this.changeEnable}
              inputProps={{ "aria-label": "secondary checkbox" }}/>הנני מאשר שקראתי את תנאי השימוש של האפליקציה</p>
            </Grid>   
            </p> 
        <MyButton text={"לתוצאות החיפוש"} onClick={this.handleClick} cursor={this.state.value}/>
        <p></p>
    </Container>
      );
    }
  } 
  export default withRouter(Confirm);
